import { render, staticRenderFns } from "./energy-year.vue?vue&type=template&id=b4075630&"
import script from "./energy-year.vue?vue&type=script&lang=js&"
export * from "./energy-year.vue?vue&type=script&lang=js&"
import style0 from "./energy-year.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports